<template>
  <router-view
    ref="child"
    :showCurrency="showCurrency"
    :selectedCountry="selectedCountry"
    :countries="countries"
  />
</template>

<script>
import resources from "../../resources";

export default {
  data() {
    return {
      countries: {
        data: [],
        loading: true,
        error: false,
      },
      selectedCountry: null,
      internationalCurrency: null,
    };
  },
  computed: {
    showCurrency() {
      return this.selectedCountry
        ? this.selectedCountry.show_currency.data
        : this.internationalCurrency;
    },
  },
  methods: {
    loadPurchaseOptions() {
      this.$refs.child.loadPurchaseOptions();
    },
    loadCountries() {
      this.countries.data = [];
      this.countries.loading = true;
      this.countries.error = false;

      Promise.all([
        resources.countries.index({
          payable: 1,
          per_page: 999,
          include: ["is_current", "show_currency"],
        }),
        resources.currencies.index({ default: 1 }), //Es para traer la default para el "internacional", despues cada pais trae su moneda o la default
      ])
        .then(([countriesResponse, currencyResponse]) => {
          this.internationalCurrency = currencyResponse.data.data[0];
          this.countries.data = countriesResponse.data.data;
          this.countries.loading = this.countries.error = false;
          this.selectedCountry =
            this.countries.data.find(
              (country) => country.is_current === true
            ) || null;
          this.loadPurchaseOptions();

          if (!this.internationalCurrency) {
            return (this.countries.error = true);
          }
        })
        .catch((err) => {
          this.countries.loading = false;
          this.countries.error = true;
        });
    },
  },
  mounted() {
    this.loadCountries();
  },
};
</script>
